import { useEffect, useState } from "react"
import { LocationIcon, BedIcon, CurrencyIcon, HouseIcon } from "../assets/CommonIcons"

export {ChooseTypeField}

export default function InputField({ actData, setData, field, data, typeField }) {
    const [icon, setIcon] = useState(null)

    useEffect(() => {
        if (field === 'type') {
            setIcon(<FieldIcon icon={<HouseIcon />} />)
        }
        if (field === 'location') {
            setIcon(<FieldIcon icon={<LocationIcon />} />)
        }
        if (field === 'bedrooms') {
            setIcon(<FieldIcon icon={<BedIcon />} />)
        }
        if (field === 'price') {
            setIcon(<FieldIcon icon={<CurrencyIcon />} />)
        }
    }, [field])

    const handleChangeSelect = (e) => {
        const { name, value } = e.target

        setData((prevData) => ({
            ...prevData,
            [name]: value
        }))
    }

    const LocationField = () => {
        return (<>
            <label htmlFor="local"> Localização </label>
            <select onChange={handleChangeSelect} value={actData.local} name="local" id="" className='text-black p-3 rounded-md bg-slate-100 focus:rounded-b-none'>
         <optgroup className="text-black" label='São Paulo'>
                    {data.map((bairro, index) => (
                        <option key={index} value={bairro}>
                            {bairro}
                        </option>
                    ))}
                </optgroup>
            </select>
        </>
        )
    }
    const BedroomsField = () => {
        return (<>
            <label htmlFor=""> De Quantos Quartos Você Precisa? </label>
            <select value={actData.quartos} onChange={handleChangeSelect} name="quartos" id="" className='text-black p-3 bg-slate-100 rounded-md focus:rounded-b-none'>
                <option value="1 Quarto ou Mais">1+</option>
                <option value="2 Quartos ou Mais">2+</option>
                <option value="3 Quartos ou Mais">3+</option>
            </select>
        </>
        )
    }
    const MaxComprar = () => {
        return (<>
            <label htmlFor=""> Valor Maximo: </label>
            <select value={actData.valor} onChange={handleChangeSelect} name="valor" id="" className='text-black p-3 bg-slate-100 rounded-md focus:rounded-b-none'>
                <option value="Max R$100k">Até R$100.000</option>
                <option value="Max R$200k">Até R$200.000</option>
                <option value="Max R$300k">Até R$300.000</option>
                <option value="Max R$400k">Até R$400.000</option>
                <option value="Max R$500k">Até R$500.000</option>
                <option value="Max R$800k">Até R$800.000</option>
                <option value="Max R$1 Milhão">Até R$1.000.000</option>
            </select>
        </>)
    }
    const MaxAluguel = () => {
        return (<>
            <label htmlFor=""> Valor Mensal Maximo: </label>
            <select value={actData.valor} onChange={handleChangeSelect} name="valor" id="" className='text-black p-3 bg-slate-100 rounded-md focus:rounded-b-none'>
                <option value="Max R$500/mês">Até R$500 /mês</option>
                <option value="Max R$800/mês">Até R$800 /mês</option>
                <option value="Max R$1.000/mês">Até R$1.000 /mês</option>
                <option value="Max R$2.000/mês">Até R$2.000 /mês</option>
                <option value="Max R$3.000/mês">Até R$3.000 /mês</option>
                <option value="Max R$4.000/mês">Até R$4.000 /mês</option>
            </select>
        </>
        )
    }

    return (
        <div className='flex gap-x-5 items-center'>
            {icon}
            <div className="relative border-r h-full"></div>
            <span className="grid items-center w-full">
                {field === 'location' ? <LocationField /> : null}
                {field === 'bedrooms' ? <BedroomsField /> : null}
                {field === 'price' && typeField === 'Aluguel' ? <MaxAluguel /> : null}
                {field === 'price' && typeField === 'Venda' ? <MaxComprar /> : null}
            </span>
        </div>
    )
}

const FieldIcon = ({ icon }) => {
    return (
        <span className='w-10 aspect-square col-span-1 fill-white'>{icon}</span>
    )
}

const ChooseTypeField = ({ actData, setData, setType }) => {
    const [activeField, setActiveField] = useState('Aluguel')

    const style = {
        background: '#0003',
        padding: '.4rem',
        borderRadius: '.4rem',
        transition: '.8s'
    }
    const activeStyle = {
        background: '#2b6aeb',
        boxShadow: '0 0 2rem #2b6aeb',
        borderBottom: '1px solid #fff',
        padding: '.4rem',
        borderRadius: '.7rem',
    }
    const handleClick = (field) => {
        setActiveField(field)
        setType(field)
    }

    return (<>
        <div className="flex items-center text-center text-white w-full">
            <span style={activeField === 'Aluguel' ? activeStyle : style} className="w-full h-full hover:cursor-pointer hover:border-b"
                onClick={() => handleClick('Aluguel')}> Aluguel </span>
            <div className='h-3 border mx-10'></div>
            <span style={activeField === 'Venda' ? activeStyle : style} className="w-full h-full hover:cursor-pointer hover:border-b"
                onClick={() => handleClick('Venda')}> Venda </span>
        </div>
    </>)
}